const moreSvg = `<svg aria-hidden='true' viewBox='0,0,1792,1792'><title>More</title><path d='M979 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23zm384 0q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z'></path></svg>`;

export default function genderNeutralRestroomPopup(model) {
	return `<div class='content-wrapper gender-neutral-popup clearfix' style='color:white;' data-key='${model.key}'>
	<div class='popup-row'>
		<div class='popup-col'>
			<h3 id='popup-name' class='gender-neutral-restroom-title'>${model.data.map_object.name}</h3>
		</div>
	</div>
	<p class='gender-neutral-restroom-description'>
		${model.data.description}
	</p>
	<p>
		${model.data.ada_accessible ? 'This restroom is ADA Accessible' : 'This restroom is not ADA Accessible'}
	</p>
	<br />
	<p class='align-right'>
		<button
			type='button'
			class='more_button'
			data-dialog-url='${model.htmlView}'
			data-dialog-gender-neutral-restroom='${model.id}'
			aria-describedby='popup-name'
		>
			More details 
			<span class="uw-sr-only">about ${model.data.name}</span>
			${moreSvg}
		</button>
	</p>
</div>`;
}
